<template>
  <div class="coin-seller">
    <!-- 顶部导航栏 -->
    <van-nav-bar placeholder safe-area-inset-top @click-left="goBack" left-arrow >
      <template #title>
        <div class="coin-seller_nav">
          <van-tabs v-model="navTab" line-width="15px" background="unset" @click="navTabBtn">
            <van-tab title="Seller" name="Seller"></van-tab>
            <van-tab title="Buyer" name="Buyer"></van-tab>
          </van-tabs>
        </div>
      </template>
    </van-nav-bar>
    <van-row>
      <van-col span="24" v-if="navTab === 'Seller'">
        <!-- 子导航 -->
        <van-col span="16" offset="4" class="coin-seller_sub">
          <van-col span="11" class="sub-nav-item" :class="{'sub-nav-active': subTab === 'overview'}" @click="subTab = 'overview'">
            <img src="../assets/img/coin_seller_trading.png" v-if="subTab === 'overview'"/> {{ $t('column.overview')}}
          </van-col>
          <van-col span="11" offset="2" class="sub-nav-item" :class="{'sub-nav-active': subTab === 'trading'}" @click="subTab = 'trading'">
           <img src="../assets/img/coin_seller_trading.png" v-if="subTab === 'trading'"/> {{ $t('column.trading')}}
          </van-col>
        </van-col>
        <!-- Overview 页面内容 -->
        <van-col span="22" offset="1" class="coin-seller-overview" v-if="subTab === 'overview'">
          <!-- 用户信息卡片 -->
          <van-col span="24">
            <van-col span="4">
              <van-image round width="14vw" height="14vw" :src="userInfo.avatar" fit="cover" />
            </van-col>
            <van-col span="20">
              <van-col span="24" class="user-name">
                {{ userInfo.name }}  <img :src="userInfo.seller_level_img" v-if="userInfo.seller_level_img"/>
              </van-col>
              <van-col span="24" class="user-id">ID:<span id="creator_user_id">{{ userInfo.user_id }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('creator_user_id')"/></van-col>
            </van-col>

          </van-col>
          <!-- 统计信息 -->
          <van-col span="24" class="stats-row">
            <van-col span="12">
              <van-col span="24" class="stat-label">{{ $t('column.coins_sold') }}</van-col>
              <van-col span="24" class="stat-value">
                <img src="../assets/img/coin10.png"/>  {{ userInfo.seller_coin }}
              </van-col>
            </van-col>
            <van-col span="12">
              <van-col span="24" class="stat-label">{{ $t('column.customer_numbers')}}</van-col>
              <van-col span="24" class="stat-value">{{ userInfo.customer_sum }}</van-col>
            </van-col>
          </van-col>
          <!-- 支付方式和等级排名 -->
          <van-col span="24" class="info-row">
            <van-col span="12" @click="showPaymentMethod">
              <van-col span="24" class="info-label">{{ $t('column.payment_method')}}</van-col>
              <van-col span="20" class="info-content">
                <img :src="country_img" class="info-content-img" v-if="country_img"/> <van-icon name="arrow" size="14" />
              </van-col>
            </van-col>
            <van-col span="12"  @click="showRanking">
              <van-col span="24" class="info-label">{{ $t('column.coinseller_rank')}}</van-col>
              <van-col span="16" class="info-content">
                <van-image
                    v-for="(item, index) in coinselller_rank"
                    :key="index"
                    round width="20" height="20"
                    :src="item.head_image"
                    :style="{ marginLeft: index > 0 ? '-8px' : '0' }"
                />
                <van-icon name="arrow" size="14" />
              </van-col>
            </van-col>
          </van-col>
          <!-- 规则表格 -->
          <van-col span="24" class="rules-section">
            <van-col span="12" class="rules-title"  @click="rulesTab = 'DepositRules'">
              {{ $t('column.deposit_rules')}}
              <div :class="{'rules-title-active': rulesTab === 'DepositRules'}"></div>
            </van-col>
            <van-col span="12" class="rules-title" @click="rulesTab = 'LevelUpRules'">
              {{ $t('column.level_up_rules')}}
              <div :class="{'rules-title-active': rulesTab === 'LevelUpRules'}"></div>
            </van-col>
          </van-col>
          <!-- 等级规则 -->
          <van-col span="24" class="rules-table" v-if="rulesTab === 'LevelUpRules'">
            <van-col span="22" offset="1" class="table-header">
              <van-col span="6" class="table-cell"></van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.senior_seller')}}</van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.standard_seller')}}</van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.beginner_seller') }}</van-col>
            </van-col>
            <!-- 数据 -->
            <van-col span="22" offset="1" class="table-row-list">
              <van-col span="24" class="table-cell-title">{{ $t('column.exchange_recharge') }}</van-col>
              <!--     exchange       -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell">
                  <van-col span="24" class="rule-name-color"> {{ $t('column.exchange') }}</van-col>
                  <van-col span="24" class="rule-name-coin">
                    <img src="../assets/img/coin9.png"/> {{rulesData.exchange.diamond }}=
                    <img src="../assets/img/coin10.png"/> {{rulesData.exchange.coin }}
                  </van-col>
                  <van-col span="24" class="rule-name-from">
                    From  <img src="../assets/img/coin9.png"/> {{rulesData.exchange.from }}
                  </van-col>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="18" v-if="rulesData.exchange.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="18" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="18" v-if="rulesData.exchange.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="18" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="18" v-if="rulesData.exchange.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="18" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell">
                  <van-col span="24" class="rule-name-color"> {{ $t('column.recharge') }}</van-col>
                  <van-col span="24" class="rule-name-coin">
                    ${{rulesData.recharge.money }}=
                    <img src="../assets/img/coin10.png"/> {{rulesData.recharge.coin }}
                  </van-col>
                  <van-col span="24" class="rule-name-from">
                    {{ $t('column.from')}} ${{rulesData.recharge.from }}
                  </van-col>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.recharge.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.recharge.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.recharge.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>

              <van-col span="24" class="table-cell-title">{{ $t('column.sales_methods') }}</van-col>
              <!--    sales methods      -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1">
                  {{ $t('column.coin_seller')}} -> {{ $t('column.user')}}
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1">
                  {{ $t('column.coin_seller')}} -> {{ $t('column.coin_seller')}}
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col span="24" class="table-cell-title">{{ $t('column.privilege') }}</van-col>
              <!--   privilege     -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.seller_list')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.coin_selling_list')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.seller_tag')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.senior_seller_tag" v-if="rulesData.seller_tag.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.standard_seller_tag" v-if="rulesData.seller_tag.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.beginner_seller_tag" v-if="rulesData.seller_tag.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="table-row-usd">*{{ $t('column.recharge_with_usd') }}: $1= <img src="../assets/img/coin10.png"/> {{ recharge_usd_ratio }} </van-col>
          </van-col>
          <van-col span="24" class="rules-table" v-else>
            <van-col span="22" offset="1" class="coin_seller_rules_deposit" v-html="deposit_rules"> </van-col>
          </van-col>
          <van-col span="24" class="rules-table-quit" @click.native="coin_seller_quit" v-if="userInfo.status === '1' && userInfo.deposit_coin > 0"> {{ $t('column.quit_as_coinSeller_role')}} <van-icon name="arrow" /></van-col>
          <van-col span="20" offset="2" class="rules_become_coin_seller" @click.native="become_coin_seller" v-if="userInfo.status === '1' && userInfo.deposit_coin <= 0">
            <van-button color="#FF61F5" block round>{{ $t('column.become_coin_seller')}}</van-button>
          </van-col>
          <van-col span="24" class="cancel_quit_bottom"v-if="userInfo.status === '2'">
            <van-button color="#f2a742" block round v-if="is_creator_agency == 1 && quit_endtime > 0" @click.native="coin_seller_cancel_quit" >
              <van-col span="24" class="cancel_quit_bottom_title">{{ $t('column.cancel_quit')}}</van-col>
              <van-col span="24" class="cancel_quit_bottom_day"><van-count-down :time="quit_endtime" format="DD Day HH:mm:ss" /></van-col>
            </van-button>
             <van-button color="#f2a742" block round v-if="quit_endtime > 0">
               <van-col span="24" class="cancel_quit_bottom_title">{{ $t('column.due_date')}}</van-col>
              <van-col span="24" class="cancel_quit_bottom_day"><van-count-down :time="quit_endtime" format="DD Day HH:mm:ss" /></van-col>
            </van-button>
          </van-col>
        </van-col>
        <!-- trading 页面内容 -->
        <van-col span="22" offset="1" class="trading-content" v-else-if="subTab === 'trading'">
          <!-- 当前等级显示 -->
          <van-col span="24" class="current-level">{{ $t('column.current_level')}}: {{ currentLevel }} </van-col>
          <!-- 余额信息 -->
          <van-col span="24" class="balance-section">
            <van-col span="16" class="balance-main">
              <span class="balance-title">{{ $t('column.Total_balance')}}:</span>
              <span class="balance-value"><img src="../assets/img/coin10.png"/> {{ totalBalance }}</span>
            </van-col>
            <van-col span="8" class="balance-details" @click="showDetails">
              {{ $t('column.details')}} <van-icon name="arrow" size="16"/>
            </van-col>
            <van-col span="12">
              <span class="sub-balance-label">{{ $t('column.available_balance')}}</span>
              <span class="sub-balance-value"><img src="../assets/img/coin10.png"/> {{ availableBalance }}</span>
            </van-col>
            <van-col span="12" class="sub-balance">
              <span class="sub-balance-label">{{ $t('column.security_deposit')}}:</span>
              <span class="sub-balance-value"><img src="../assets/img/coin10.png"/> {{ securityDeposit }}</span>
            </van-col>
            <!-- 提示信息 -->
            <van-col span="24" class="warning-message" v-if="securityDeposit <= 0 && userInfo.status === '1'">
              <van-icon name="info" color="#fda119" size="20"/>
              {{ $t('column.deposit_sum_required_activate',{number: seller_security_deposit })}}
            </van-col>
            <van-col span="24" class="warning-message" v-else-if="quit_endtime > 0">
              <van-icon name="info" color="#fda119" size="20"/>
              {{ $t('column.security_deposit_will_available_balance',{time: formattedTime })}}
            </van-col>
          </van-col>

          <!-- 操作按钮 -->
          <van-col span="24" class="action-buttons">
            <van-col span="8" class="action-btn" :class="{'action-btn-nav-active': activeTab === 'transfer'}" @click="activeTabBtn('transfer')">
              <van-icon name="lock" size="16" v-if="!userInfo.transfer_seller_active && !userInfo.transfer_user_active"/>
              {{ $t('column.Transfer')}}
            </van-col>
            <van-col span="8" class="action-btn" :class="{'action-btn-nav-active': activeTab === 'recharge'}" @click="activeTabBtn('recharge')">
              <van-icon name="lock" size="16" v-if="!userInfo.recharge_active || userInfo.status ==='2'"/>
              {{ $t('column.recharge')}}
            </van-col>
            <van-col span="8" class="action-btn" :class="{'action-btn-nav-active': activeTab === 'exchange'}" @click="activeTabBtn('exchange')">
              <van-icon name="lock" size="16" v-if="!userInfo.exchange_active || userInfo.status ==='2'"/>
              {{ $t('column.exchange')}}
            </van-col>
          </van-col>
          <van-col span="24" class="action-content">
            <!--    transfer 转让      -->
            <van-col span="22" offset="1" v-if="activeTab === 'transfer' && (userInfo.transfer_seller_active || userInfo.transfer_user_active)">
              <van-col span="10" class="action-content-transfer-type-name"> {{ $t('column.sales_methods')}}: </van-col>
              <van-col span="14" class="action-content-transfer-type">
                <van-tabs v-model="TransferActiveType"  @click="TransferActiveTypeBtn" class="action-content-transfer-type-tabs" type="card" color="#ffffff" background="#EDF2F8" title-active-color="#1A1A1A" title-inactive-color="#5E5D65">
                  <van-tab title="User" name="User" v-if="userInfo.transfer_user_active"></van-tab>
                  <van-tab title="Coinseller" name="CoinSeller" v-if="userInfo.transfer_seller_active"></van-tab>
                </van-tabs>
              </van-col>
              <van-col span="24" class="action-content-transfer-title">{{ $t('column.user_id')}}:</van-col>
              <van-col span="24" class="action-content-transfer-input">
                <van-field v-model="transferFrom.user_id" :placeholder="$t('column.please_input_user_id')" >
                  <template #button>
                    <van-button size="small" @click="checkUserId">{{ $t('column.check')}}</van-button>
                  </template>
                </van-field>
              </van-col>
              <van-col span="24" class="action-content-transfer-name" v-if="transferFrom.nick_name"> <img :src="transferFrom.head_image"/> {{ transferFrom.nick_name }} </van-col>
              <van-col span="24" class="action-content-transfer-title">{{ $t('column.amount')}}:</van-col>
              <van-col span="24" class="action-content-transfer-input">
                <van-field v-model="transferFrom.coin" :placeholder="$t('column.please_enter')"  @input="transferFromMonitor"/>
              </van-col>
              <van-col span="24" class="action-content-transfer-text">
                {{ $t('column.will_receive_diamonds')}}:
                {{ transferFrom.ticket }}
                <img src="../assets/img/coin11.png" v-if="TransferActiveType == 'User'"/><img src="../assets/img/coin10.png" v-else/>
              </van-col>
              <van-col span="22" offset="1" class="action-content-transfer-botton">
                <van-button color="#FF61F5" block round @click="TransferBtn">{{ $t('column.Transfer')}}</van-button>
              </van-col>
            </van-col>
            <!-- Recharge 充值选项 -->
            <van-col span="24" v-if="activeTab === 'recharge'">
              <van-col span="10" class="recharge-title">
                <van-col span="11" class="recharge-title-nav-item" :class="{'recharge-title-active': OfficialSellerTab === 'official'}" @click="OfficialSellerTabBtn('official')">
                  {{ $t('column.official')}}
                  <div></div>
                </van-col>
                <van-col span="11" offset="2" class="recharge-title-nav-item" :class="{'recharge-title-active': OfficialSellerTab === 'seller'}" @click="OfficialSellerTabBtn('seller')">
                  {{ $t('column.seller')}}
                  <div ></div>
                </van-col>
              </van-col>
              <van-col span="13" class="recharge-title">
                <van-cell is-link arrow-direction="down" class="recharge-title-cell" v-if="OfficialSellerTab === 'official'"  @click="RechargePaymentShow = true">
                  <template #default>
                    <span class="recharge_title_left">
                      <img :src="rechargePanmentCheck.img"/>
                      <span>{{ rechargePanmentCheck.name}}</span>
                    </span>
                    {{ rechargePanmentCheck.currency_type_name}}

                  </template>
                </van-cell>
                <van-cell is-link arrow-direction="down" class="recharge-title-cell" v-if="OfficialSellerTab === 'seller'" @click="CurrencySellerShow = true">
                  <template #default>

                    <span class="recharge_title_left">
                     <img :src="currency_type[CurrencySellerIndex].img"/>
                      <span>{{ currency_type[CurrencySellerIndex].name}}</span>
                    </span>
                    {{ currency_type[CurrencySellerIndex].country_name}}
                  </template>
                </van-cell>
              </van-col>
              <van-col span="24"  v-if="OfficialSellerTab === 'official'">
                <van-col span="12" class="recharge-option" @click.native="OfficialRecharge(0)">
                  <!--   自定义充值    -->
                  <van-col span="22" offset="1" class="recharge-option-custom">{{ $t('column.custom_recharge') }} </van-col>
                </van-col>
                <van-col span="12" class="recharge-option"  v-for="(option, index) in rechargeOptions" :key="index" @click.native="rechargeOptionsSelect = index">
                  <van-col span="22" offset="1" class="recharge-option-bg" :class="{'recharge-option-active': rechargeOptionsSelect === index}" >
                    <van-col span="24" class="option-amount"><img src="../assets/img/coin10.png"/> {{ option.seller_coin }}</van-col>
                    <van-col span="24" class="recharge-option-bg-img" v-if="option.seller_level_img">
                      <img :src="option.seller_level_img"/>
                    </van-col>
                    <van-col span="24" class="option-price">${{ option.money }}</van-col>
                  </van-col>
                </van-col>
                <van-col span="22" offset="1" class="recharge-btn">
                  <van-button color="#FF61F5" block round @click="OfficialRecharge(1)"> {{ $t('column.recharge') }}</van-button>
                </van-col>
              </van-col>
              <van-col span="24" v-if="OfficialSellerTab === 'seller'">
                <van-col span="22" offset="1" class="recharge-option-seller"  v-for="(option, index) in sellerUserList" :key="index">
                  <van-col span="24">
                    <van-col span="4" class="recharge-option-seller-avatar">
                      <van-image round width="12vw" height="12vw" :src="option.head_image" fit="cover" class="recharge-option-seller-avatar-offline" :class="{'recharge-option-seller-avatar-online': option.is_online == 1}"/>
                      <div class="recharge-option-seller-online" v-if="option.is_online">{{ $t('column.online')}}</div>
                      <div class="recharge-option-seller-offline" v-else>{{ $t('column.offline')}}</div>
                    </van-col>
                    <van-col span="16">
                      <van-col span="24" class="recharge-option-seller-name"> {{ option.nick_name }} <img :src="option.seller_level_img" v-if="option.seller_level_img"/> </van-col>
                      <van-col span="24" class="recharge-option-seller-data">{{ $t('column.deal_of_last_30_days')}}</van-col>
                    </van-col>
                    <van-col span="4" class="recharge-option-seller-msg"  @click="privateMessage(option.user_id)">
                      <img src="../assets/img/creator/creator_agency_message.png" />
                    </van-col>
                  </van-col>
                  <van-col span="24" class="recharge-option-seller_type">
                    {{ $t('column.payment_methood')}}:
                    <img :src="i.img" v-for="(i,j) in option.payment_method_img" :key="j"/>
                  </van-col>
                  <van-col span="24" class="recharge-option-seller_text">{{ $t('column.recharge_available_host_add_agency')}}</van-col>
                </van-col>
              </van-col>

            </van-col>
            <!--     exchange 兑换     -->
            <van-col span="22" offset="1" v-if="activeTab === 'exchange'">
              <van-col span="24" class="action-content-exchange">{{ $t('column.my_beans')}}: {{ userInfo.ticket }} <img src="../assets/img/coin9.png"/> </van-col>
              <van-col span="12" class="recharge-option" @click.native="ExchangeShowBtn(0)">
                <!--   自定义兑换     -->
                <van-col span="22" offset="1" class="recharge-option-custom">{{ $t('column.custom_exchange') }} </van-col>
              </van-col>
              <van-col span="12" class="recharge-option"  v-for="(option, index) in exchangeOptions" :key="index" @click.native="exchangeOptionsSelect = index">
                <van-col span="22" offset="1" class="recharge-option-bg" :class="{'recharge-option-active': exchangeOptionsSelect === index}" >
                  <van-col span="24" class="option-amount"><img src="../assets/img/coin10.png"/> {{ option.coin }}</van-col>
                  <van-col span="24" class="recharge-option-bg-img" v-if="option.seller_level_img">
                    <img :src="option.seller_level_img"/>
                  </van-col>
                  <van-col span="24" class="option-price"><img src="../assets/img/coin9.png"/> {{ option.ticket }}</van-col>
                </van-col>
              </van-col>
              <van-col span="22" offset="1" class="recharge-btn" @click="ExchangeShowBtn(1)">
                <van-button color="#FF61F5" block round> {{ $t('column.exchange')}}</van-button>
              </van-col>
            </van-col>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="24" v-else>
        <van-col span="18" offset="3">
          <van-tabs :type="BuyerTab" class="coin-seller-buyer-tab" @click="BuyerTabBtn">
            <van-tab title="Recommend" name="Recommend"></van-tab>
            <van-tab title="Old Buyer" name="OldBuyer"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="22" offset="1" class="coin-seller-buyer-tab-bg" v-if="BuyerTab === 'Recommend'">
          <!--    Recommend      -->
          <van-col span="10">
            <van-cell is-link arrow-direction="down" :value="buyer_type_list[buyer_recommend_index].name" @click="BuyerTabTypeBtn"/>
          </van-col>
          <van-col span="13" class="coin-seller-buyer-tab-guide" @click.native="EditQuickMessagesBtn">
            <img src="../assets/img/guide.png"/>  {{ $t('column.edit_quick_messages')}}
          </van-col>
          <van-col span="22" offset="1">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('other.there_is_no_more')"
                :loading-text="$t('other.Loading')"
                @load="onLoad"
            >
              <van-cell v-for="(item,s) in new_buyer_list" :key="s" class="coin-seller-buyer-tab-list">
                <van-col span="24">
                  <van-col span="4" class="coin-seller-buyer-tab-avatar">
                    <img :src="item.head_image"/>
                  </van-col>
                  <van-col span="16" class="coin-seller-buyer-tab-user">
                    <van-col span="24" class="coin-seller-buyer-tab-user_name">
                      {{ item.nick_name }} <img :src="item.user_level_url"/>
                    </van-col>
                    <van-col span="24" class="coin-seller-buyer-tab-user-id">
                      <span :class="item.user_type === 'User'?'coin-seller-buyer-tab-user_name-span' : 'coin-seller-buyer-tab-user_name-span-seller'">{{ item.user_type }}</span>
                      ID:<span :id="'Recommend_user_id' + s">{{ item.touid }}</span>
                      <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('Recommend_user_id' + s)"/>
                    </van-col>
                  </van-col>
                  <van-col span="4" class="coin-seller-buyer-tab-creator">
                    <img src="../assets/img/guide2.png" @click="SendMessage(item.touid)"/>
                  </van-col>
                </van-col>
              </van-cell>
            </van-list>
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="coin-seller-buyer-tab-bg" v-else>
          <!--    OldBuyer      -->
          <van-col span="12">
            <van-cell is-link arrow-direction="down" :value="buyer_type_list[buyer_type_index].name" @click="BuyerTabTypeBtn"/>
          </van-col>

          <van-col span="22" offset="1">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('other.there_is_no_more')"
                :loading-text="$t('other.Loading')"
                @load="onLoad"
            >
              <van-cell v-for="(item,j) in old_buyer_list" :key="j" class="coin-seller-buyer-tab-list">
                <van-col span="24">
                  <van-col span="4" class="coin-seller-buyer-tab-avatar">
                    <img :src="item.head_image"/>
                  </van-col>
                  <van-col span="16" class="coin-seller-buyer-tab-user">
                    <van-col span="24" class="coin-seller-buyer-tab-user_name">
                      {{ item.nick_name }} <img :src="item.user_level_url"/>
                    </van-col>
                    <van-col span="24" class="coin-seller-buyer-tab-user-id">
                      <span :class="item.user_type === 'User'?'coin-seller-buyer-tab-user_name-span' : 'coin-seller-buyer-tab-user_name-span-seller'">{{ item.user_type }}</span>
                      ID:<span :id="'buyer_user_id' + j">{{ item.touid }}</span>
                      <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('buyer_user_id' + j)"/>
                    </van-col>
                  </van-col>
                  <van-col span="4" class="coin-seller-buyer-tab-creator">
                    <img src="../assets/img/creator/creator_agency_message.png" @click="privateMessage(item.touid)"/>
                  </van-col>
                </van-col>
                <van-col span="24">
                  <van-col span="10" class="coin-seller-buyer-tab-centent">
                    <van-col span="24" class="coin-seller-buyer-tab-centent-name">{{ $t('column.trade_last_days_30') }}</van-col>
                    <van-col span="24" class="coin-seller-buyer-tab-centent-number"> <img src="../assets/img/coin11.png" v-if="item.type === '1'"/><img src="../assets/img/coin10.png" v-else/> {{ item.diamonds_sum }}</van-col>
                  </van-col>
                  <van-col span="7" class="coin-seller-buyer-tab-centent">
                    <van-col span="24" class="coin-seller-buyer-tab-centent-name">{{ $t('column.trade_times') }}</van-col>
                    <van-col span="24" class="coin-seller-buyer-tab-centent-number">{{ item.trade_times }}</van-col>
                  </van-col>
                  <van-col span="7" class="coin-seller-buyer-tab-centent">
                    <van-col span="24" class="coin-seller-buyer-tab-centent-name">{{ $t('column.last_trade') }}</van-col>
                    <van-col span="24" class="coin-seller-buyer-tab-centent-number">{{ item.create_time }}</van-col>
                  </van-col>
                </van-col>
              </van-cell>
            </van-list>
          </van-col>
        </van-col>
      </van-col>
      <van-dialog v-model="payment_method_show" show-cancel-button :close-on-click-overlay="false">
        <van-col span="24" class="payment_method_show_title"> {{ $t('column.please_finish_first')}}  </van-col>
        <van-col span="20" offset="2" class="payment_method_show_add" @click.native="CurrencyTypeShowBtn">
          <van-icon name="plus" color="#FF61F5" size="18px" /> {{ $t('column.add_payment_method') }}
        </van-col>
      </van-dialog>
      <van-popup v-model="CurrencyTypeShow" position="bottom"  round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in currency_type" :key="index" @click="jump_href(item.currency_type_id)">
            <van-col span="12" class="currency_type_list_name"> <img :src="item.country_img"/> {{ item.country_name }} </van-col>
            <van-col span="12" class="currency_type_list_item_content"> {{ item.currency_name }} <van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
      <van-popup v-model="CurrencySellerShow" position="bottom"  round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in currency_type" :key="index" @click="CurrencySellerSelect(index)">
            <van-col span="12" class="currency_type_list_name"> <img :src="item.img"/> {{ item.name }} </van-col>
            <van-col span="12" class="currency_type_list_item_content"> {{ item.currency_name }} <van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
      <van-popup v-model="ExchangeShow" position="bottom" round >
        <van-col span="24" class="exchange_show_title"> {{ $t('column.exchange_coins')}}  </van-col>
        <van-col span="24" class="exchange_show_div">
          <van-col span="22" offset="1" class="exchange_show_div_item" v-if="exchangeFrom.id">
            <van-col span="24" class="exchange_show_div_item_name" v-if="exchangeFrom.seller_level_text"> <img src="../assets/img/upgrade_img.png"/> {{ $t('column.level_up_to_seller',{name: exchangeFrom.seller_level_text })}} </van-col>
            <van-col span="24" class="exchange_show_div_item_val">
              <van-col span="11" class="exchange_show_div_item_val_name">
                <van-col span="24" class="exchange_show_div_item_val_name_coin">
                  <img src="../assets/img/coin9.png"/>
                </van-col>
                <van-col span="24" class="exchange_show_div_item_val_name_sum"> {{ exchangeFrom.ticket }} </van-col>
                <van-col span="24" class="exchange_show_div_item_val_name_title">{{ ticket_name }}</van-col>
              </van-col>
              <van-col span="2" class="exchange_show_div_item_val_centent"> <img src="../assets/img/left_jiantou.png"/> </van-col>
              <van-col span="11" class="exchange_show_div_item_val_name">
                <van-col span="24" class="exchange_show_div_item_val_name_coin">
                  <img src="../assets/img/coin10.png"/>
                </van-col>
                <van-col span="24" class="exchange_show_div_item_val_name_sum">{{ exchangeFrom.coin }} </van-col>
                <van-col span="24" class="exchange_show_div_item_val_name_title">{{ seller_currency_name }}</van-col>
              </van-col>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="exchange_show_div_input" v-else>
            <van-field
                v-model="exchangeFrom.ticket"
                center
                clearable
                @input="inputMonitor"
            >
              <template #label>
                <van-col span="24" class="exchange_show_div_input_ticket">
                  <img src="../assets/img/coin9.png"/>
                </van-col>
              </template>
              <template #button>
                <van-col span="24" class="exchange_show_div_input_coin">
                  <img src="../assets/img/coin10.png"/> {{ exchangeFrom.coin ? exchangeFrom.coin : '' }}
                </van-col>
              </template>
            </van-field>
          </van-col>
          <van-col span="22" offset="1" class="exchange_show_btn">
            <van-button color="#FABCF9" block round v-if="exchangeFrom.seller_level > 0 && userInfo.seller_level !== exchangeFrom.seller_level"> {{ $t('column.exchange')}}</van-button>
            <van-button color="#FF61F5" block round  @click="exchangeSubmit" v-else> {{ $t('column.exchange')}}</van-button>
          </van-col>
        </van-col>
      </van-popup>

      <van-popup v-model="BuyerTabTypeShow" position="bottom" round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in buyer_type_list" :key="index" @click="buyer_typeSelect(index)">
            <van-col span="12" class="currency_type_list_name"> {{ item.name }} </van-col>
            <van-col span="12" class="currency_type_list_item_content"> {{ item.currency_name }} <van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
      <van-popup v-model="RechargePaymentShow" position="bottom" round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.official')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in recharge_payment" :key="index" @click="RechargePaymentSelect(index)">
            <van-col span="18" class="currency_type_list_name"> <img :src="item.img"/> {{ item.name }} </van-col>
            <van-col span="6" class="currency_type_list_item_content"><van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
      <van-popup v-model="RechargeShow" closeable position="bottom" :style="{ paddingBottom: '10vw' }" round >
        <van-col span="24" class="recharge_offline_title"> {{ $t('column.recharge_offline_coins')}} </van-col>
        <van-col span="22" offset="1" class="recharge_offline_centent">
          <van-col span="24" class="recharge_offline_centent_bg" v-if="rechargeOptionsCheck.id ">
            <van-col span="8" offset="2" class="recharge_offline_centent_bg_money"> $ {{ rechargeOptionsCheck.money }} </van-col>
            <van-col span="4" class="recharge_offline_centent_bg_icon"> <van-icon name="down" /> </van-col>
            <van-col span="8" class="recharge_offline_centent_bg_coin">
              <img src="../assets/img/coin10.png"/> {{ rechargeOptionsCheck.seller_coin }}
            </van-col>
          </van-col>
          <van-col span="24" class="recharge_offline_centent_bg" v-else>
            <van-field
                v-model="rechargeOptionsCheck.money"
                center
                clearable
                @input="inputMonitorRecharge"
            >
              <template #label>
                <van-col span="24" class="exchange_show_div_input_ticket"> $ </van-col>
              </template>
              <template #button>
                <van-col span="24" class="exchange_show_div_input_coin">
                  <img src="../assets/img/coin10.png"/> {{ rechargeOptionsCheck.seller_coin ? rechargeOptionsCheck.seller_coin : '' }}
                </van-col>
              </template>
            </van-field>
          </van-col>

          <van-col span="24" class="recharge_offline_method"> {{ $t('column.select_payment_method') }} </van-col>
          <van-col span="24" class="recharge_offline_method_type">
            <van-col span="16" class="recharge_offline_method_type_left">
              <img :src="rechargePanmentCheck.img" v-if="rechargePanmentCheck.img"/> {{ rechargePanmentCheck.name }}
            </van-col>
            <van-col span="8" class="recharge_offline_method_type_right">
              <img src="../assets/img/recharge_offline_sel.png"/>
            </van-col>
          </van-col>
          <van-col span="24" class="recharge_offline_btn">
            <van-button color="#FF61F5" block round @click="rechargeSubmit"> {{ $t('column.recharge')}}</van-button>
          </van-col>
        </van-col>
      </van-popup>
      <van-popup v-model="TransferRechargeShow" :style="{ width: '90%',background:'unset' }" round>
        <van-col span="24" class="transfer_recharge_bg">
          <van-col span="24" class="transfer_recharge_img">
            <img src="../assets/img/TransferRechargebg.png"/>
          </van-col>
          <van-col span="24" class="transfer_recharge_title"> {{ $t('column.pay_security_deposit')}} </van-col>
          <van-col span="20" offset="2" class="transfer_recharge_content">{{ $t('column.Recharge_paying_deposit_transfer') }} </van-col>
          <van-col span="20" offset="2" class="transfer_recharge_btn">
            <van-button color="#FF61F5" round block @click="OfficialRecharge">
              <van-col span="24" class="transfer_recharge_btn_title"> {{ $t('column.pay_deposit') }} </van-col>
              <van-col span="24" class="transfer_recharge_btn_money"> <img src="../assets/img/coin10.png"/> {{ seller_security_deposit }} </van-col>
            </van-button>
          </van-col>
        </van-col>
      </van-popup>
    </van-row>

  </div>
</template>

<script>
import '@/assets/css/style.css'
import Toast from 'vant/lib/toast'
import axios from "axios";
import {Dialog} from "vant";
import { judgeIosAndroid } from '@/assets/js/models.js'

export default {
  name: 'CoinSeller',
  data() {
    return {
      TransferRechargeShow: false,
      quit_endtime: 0,
      is_creator_agency: 0,
      quit_endtime_text: 0,
      transferFrom:{
        user_id: undefined,
        coin: undefined,
        ticket: undefined,
        nick_name: undefined,
        head_image: undefined
      },
      ticket_name: undefined,
      seller_currency_name: undefined,
      navTab: 'Seller',
      subTab: 'overview',
      rulesTab: 'LevelUpRules',
      activeTab: 'recharge',
      OfficialSellerTab: 'official',
      currentLevel: 'Beginner Seller',
      totalBalance: '0',
      availableBalance: '0',
      securityDeposit: '0',
      seller_security_deposit: undefined,
      userInfo: {},
      coinselller_rank: [],
      rulesData:{},
      recharge_usd_ratio: undefined,
      rechargeOptions: [],
      RechargeShow: false,
      rechargePanmentCheck: {
        id: undefined,
        currency_type_name: undefined,
        name: undefined,
        img: undefined,
        type: 1
      },
      rechargeOptionsCheck: {
        id: undefined,
        currency_type_name: undefined,
        money: undefined,
        seller_coin: undefined
      },
      recharge_payment: [],
      sellerUserList: [],
      exchangeOptions: [],
      RechargePaymentShow: false,
      rechargeOptionsSelect: 0,
      RechargePaymentIndex: 0,
      exchangeOptionsSelect: 0,
      deposit_rules: undefined,
      currency_type: [],
      country_img: undefined,
      payment_method_show: false,
      CurrencyTypeShow: false,
      CurrencySellerShow: false,
      CurrencySellerIndex: 0,
      TransferActiveType: 'User',
      ExchangeShow: false,
      exchangeFrom:{},
      seller_exchange_rate: 1,
      seller_exchange_multiple: 0,
      BuyerTab: 'Recommend',
      BuyerTabTypeShow: false,
      buyer_type_list: [
        {id:0, name: 'ALL'},
        {id:1, name: 'User'},
        {id:2, name: 'Reseller'}
      ],
      buyer_type_index: 0,
      buyer_recommend_index: 0,
      old_buyer_list: [],
      new_buyer_list: [],
      loading: false,
      finished: false,
      page: 1
    }
  },
  created() {
    this.get_seller_recharge_rules(0)
    this.get_list()
  },
  computed: {
    // 格式化时间
    formattedTime() {
      if (this.quit_endtime_text <= 0) {
        this.quit_endtime = 0
        return '00 Day 00:00:00';
      }
      const days = Math.floor(this.quit_endtime_text / 86400);
      const hours = Math.floor((this.quit_endtime_text % 86400) / 3600);
      const minutes = Math.floor((this.quit_endtime_text % 3600) / 60);
      const seconds = this.quit_endtime_text % 60;
      return `${days.toString().padStart(2, '0')} Day ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  methods: {
    // 开始倒计时
    startCountdown() {
      if(this.userInfo.status === '2'){
        this.quit_endtime_text = this.quit_endtime / 1000
        this.timer = setInterval(() => {
          if (this.quit_endtime_text > 0) {
            this.quit_endtime_text--
          } else {
            clearInterval(this.timer);
          }
        }, 1000)
      }
    },
    onLoad() {
      if (this.page > 1){
        this.get_buyer_list()
      }
    },
    become_coin_seller() {
      this.subTab= 'trading'
    },
    coin_seller_cancel_quit() {
      Dialog.confirm({
        message: this.$t('column.is_cancel_quit'),
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        // on confirm
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=cancel_quit_coin_seller",{
          params:{uid: uid, token: token }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          Toast(res.data.error)
          if(res.data.status===1){
            this.get_list()
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    coin_seller_quit() {
      Dialog.confirm({
        message: this.$t('column.is_quit_as_coinSeller_role'),
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        // on confirm
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=quit_coin_seller",{
          params:{uid: uid, token: token }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          Toast(res.data.error)
          if(res.data.status===1){
            this.get_list()
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    rechargeSubmit(){
      Dialog.confirm({
        title: this.$t('Tips.buy_good_number'),
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
            // on confirm
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=seller_recharge_order",{
          params:{uid: uid, token: token,payment_method_id: this.rechargePanmentCheck.id,payment_method_type: this.rechargePanmentCheck.type,recharge_id: this.rechargeOptionsCheck.id,money: this.rechargeOptionsCheck.money }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          console.log(res.data)
          if(res.data.status===1){
            if (res.data.data.url){
              // 这个需要前端拦截打开浏览器
            //  window.open(res.data.data.url, '_blank')
              const url = res.data.data.url
              //  拦截
              const isIos = judgeIosAndroid();
              if (isIos === true) {
                // ios传值方法postMessage（val）传值方式
                window.webkit.messageHandlers.payment_redirect.postMessage(url)
              } else {
                // ios传值方法goSubmitted（val）传值方式
                window.AndroidJs.payment_redirect(url)
              }
            }else{
              Toast(res.data.error)
              this.jump_coin_seller_recharge(res.data.data.order_id)
            }
          }else{
            Toast(res.data.error)
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    jump_coin_seller_recharge(order_id) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_recharge', query: { uid: uid, token: token, order_id: order_id } });
    },
    OfficialRecharge(type) {
      if (type === 1){
        console.log(this.rechargeOptionsSelect)
        this.TransferRechargeShow = false
        this.rechargeOptionsCheck = this.rechargeOptions[this.rechargeOptionsSelect]
        this.RechargeShow = true
      }else{
        this.TransferRechargeShow = false
        this.rechargeOptionsCheck ={
          id: undefined,
          currency_type_name: undefined,
          money: undefined,
          seller_coin: undefined
        }
        this.RechargeShow = true
      }
    },
    get_seller_recharge_rules(index){
      this.rechargeOptionsSelect = index
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=seller_recharge_rules",{
        params:{uid: uid, token: token }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.rechargeOptions = res.data.data.recharge_options
          this.recharge_payment = res.data.data.recharge_payment
          if (this.recharge_payment.length) {
            this.rechargePanmentCheck = this.recharge_payment[0]
          }
        }else{
          Toast(res.data.error)
        }
      })
    },
    SendMessage(touid) {
      // 发送消息
      if (!this.userInfo.quick_messages){
        Toast(this.$t('column.edit_quick_messages'));
        return false
      }else{
        Dialog.confirm({
          title: this.$t('column.sure_to_send_it'),
          confirmButtonColor: '#FF61F5',
          confirmButtonText: this.$t('btn.confirm'),
          cancelButtonText: this.$t('btn.cancel'),
        }).then(() => {
          // 发送消息
          const toast = this.$toast.loading({
            duration: 0, // 持续展示
            forbidClick: true,
            message: this.$t('other.Loading') + '...',
            className: 'custom-loading-toast' // 添加自定义类名
          });
          const uid = this.$route.query.uid
          const token = this.$route.query.token
          axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=send_message",{
            params:{uid: uid, token: token, touid: touid}
          }).then(res =>{
            toast.clear(); // 关闭加载提示
            Toast(res.data.error)
          })
        }).catch(() => {
          // on cancel
        })
      }
    },
    get_buyer_list(){
      if (this.BuyerTab === 'Recommend'){
        this.get_new_buyer()
      }else{
        this.get_old_buyer()
      }
    },
    get_new_buyer(){
      this.loading = true;
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_new_buyer", {
        params: {
          uid: uid,
          token: token,
          type: this.buyer_recommend_index,
          page: this.page
        }
      }).then(res => {
        this.loading = false;
        if (this.page === 1) {
          this.new_buyer_list = []
        }
        for (let j = 0; j < res.data.data.list.length; j++) {
          res.data.data.list[j]['user_level_url'] =  require('../assets/img/rank_'+res.data.data.list[j].user_level+'.png')
          this.new_buyer_list.push(res.data.data.list[j])
        }
        //如果列表数据条数< 0，不再触发滚动加载
        if (res.data.data.list.length <= 0) {
          this.finished = true
        }
        this.page ++
      })
    },
    get_old_buyer(){
      this.loading = true;
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_old_buyer", {
        params: {
          uid: uid,
          token: token,
          type: this.buyer_type_index,
          page: this.page
        }
      }).then(res => {
        this.loading = false;
        if (this.page === 1) {
          this.old_buyer_list = []
        }
        for (let j = 0; j < res.data.data.list.length; j++) {
          res.data.data.list[j]['user_level_url'] =  require('../assets/img/rank_'+res.data.data.list[j].user_level+'.png')
          this.old_buyer_list.push(res.data.data.list[j])
        }
        //如果列表数据条数< 0，不再触发滚动加载
        if (res.data.data.list.length <= 0) {
          this.finished = true
        }
        this.page ++
      })
    },
    RechargePaymentSelect(index) {
      this.rechargePanmentCheck = this.recharge_payment[index]
      this.RechargePaymentShow = false
    },
    buyer_typeSelect(i){
      console.log(i)
      console.log(this.BuyerTab)
      if (!this.loading) {
        if (this.BuyerTab == 'Recommend') {
          this.buyer_recommend_index = i
          this.new_buyer_list = []
        }else{
          this.buyer_type_index = i
          this.old_buyer_list = []
        }
        this.page = 1
        this.finished = false
        this.get_buyer_list()
        this.BuyerTabTypeShow = false
      }
    },
    BuyerTabBtn(name, title) {
      // 中间切换板块
      this.BuyerTab = name
      this.page = 1
      this.finished = false
      if (this.BuyerTab == 'Recommend') {
        this.buyer_recommend_index = 0
        this.new_buyer_list = []
      }else{
        this.buyer_type_index = 0
        this.old_buyer_list = []
      }
      this.get_buyer_list()
      console.log(name)
    },
    BuyerTabTypeBtn() {
      this.BuyerTabTypeShow = true
    },
    navTabBtn(){
      // 顶部切换板块
     console.log( this.navTab)
      if (this.navTab == 'Buyer') {
        this.page = 1
        this.finished = false
        if (this.BuyerTab == 'Recommend') {
          this.buyer_recommend_index = 0
          this.new_buyer_list = []
        }else{
          this.buyer_type_index = 0
          this.old_buyer_list = []
        }
        this.get_buyer_list()
      }
    },
    OfficialSellerTabBtn(name) {
      if (name === 'seller') {
        this.CurrencySellerSelect(this.CurrencySellerIndex)
        this.OfficialSellerTab = name
      }else{
       // 官方
        this.OfficialSellerTab = name
      }
    },
    CurrencySellerSelect(index){
      this.CurrencySellerIndex = index
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=country_seller_list",{
        params:{uid: uid, token: token, currency_type_id: this.currency_type[this.CurrencySellerIndex].currency_type_id }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if (res.data.status===1){
          this.sellerUserList = res.data.data.list
        }else{
          Toast(res.data.error)
        }
      })
      this.CurrencySellerShow = false
    },
    privateMessage(user_id) {
      // 拦截跳转私信
      window.location.href="live://live?action=JumpUserPrivateMessage&id=" + user_id
    },
    TransferActiveTypeBtn() {
      this.transferFrom.user_id = undefined
      this.transferFrom.coin = undefined
      this.transferFrom.ticket = undefined
      this.transferFrom.nick_name = undefined
      this.transferFrom.head_image = undefined
    },
    checkUserId() {
      // 检测用户是否存在
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=check_user_or_coin_seller_exist",{
        params:{uid: uid, token: token, to_user_id: this.transferFrom.user_id, transfer_type: this.TransferActiveType }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if (res.data.status===1){
          this.transferFrom.nick_name = res.data.data.nick_name
          this.transferFrom.head_image = res.data.data.head_image
        }else{
          Toast(res.data.error)
        }

      })
    },
    transferFromMonitor(value) {
      this.transferFrom.coin = value.replace(/[^\d]/g, '');
      if (this.TransferActiveType === 'User'){
        // 转让给用户
        this.transferFrom.ticket = Math.floor(this.transferFrom.coin * this.userInfo.seller_user_rate)
      } else {
        // 转让给机构
        this.transferFrom.ticket = Math.floor(this.transferFrom.coin * this.userInfo.seller_merchant_rate)
      }
    },
    inputMonitorRecharge(value){
      let filteredValue = value.replace(/[^\d]/g, '');
      // 3. 处理大于10000的情况（向下取整到10000的倍数）
      this.rechargeOptionsCheck.seller_coin = 0
      console.log(this.seller_recharge_multiple)
      console.log(this.recharge_usd_ratio)
      if (filteredValue) {
        let num = parseInt(filteredValue, 10);
        console.log(num)
        const exchange_multiple = parseInt(this.seller_recharge_multiple)
        let multiple_num = Math.floor(num * this.recharge_usd_ratio)
        console.log(multiple_num)
        if (multiple_num > exchange_multiple) {
          multiple_num = Math.floor(multiple_num / exchange_multiple) * exchange_multiple;
          this.rechargeOptionsCheck.seller_coin = multiple_num.toString();
        }
      }
      this.rechargeOptionsCheck.money = filteredValue;
    },
    inputMonitor(value){
      let filteredValue = value.replace(/[^\d]/g, '');
      // 3. 处理大于10000的情况（向下取整到10000的倍数）
      this.exchangeFrom.coin = 0
      if (filteredValue) {
        let num = parseInt(filteredValue, 10);
        const exchange_multiple = parseInt(this.seller_exchange_multiple)
        let multiple_num = Math.floor(num / this.seller_exchange_rate)
        if (multiple_num > exchange_multiple) {
          multiple_num = Math.floor(multiple_num / exchange_multiple) * exchange_multiple;
          this.exchangeFrom.coin = multiple_num.toString();
        }
      }
      this.exchangeFrom.ticket = filteredValue;
    },
    activeTabBtn(type){
      if(type === 'exchange'){
        if(this.userInfo.exchange_active && this.userInfo.status !== '2'){
          this.activeTab = 'exchange'
        }
      } else if(type === 'recharge'){
        if(this.userInfo.recharge_active && this.userInfo.status !== '2'){
          this.activeTab = 'recharge'
        }
      }else{
        // transfer
        if(this.userInfo.transfer_seller_active || this.userInfo.transfer_user_active){
          this.activeTab = 'transfer'
          this.TransferActiveType = this.userInfo.transfer_user_active ? 'User' : 'CoinSeller'
        }else{
          if (this.userInfo.deposit_coin <= 0 && this.userInfo.status == 1){
              // 弹框显示充值
            this.TransferRechargeShow = true
          }
        }
      }
    },
    jump_href(currency_type_id) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_payment_method_select', query: { uid: uid, token: token, currency_type_id: currency_type_id } });
    },
    EditQuickMessagesBtn() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/edit_quick_messages', query: { uid: uid, token: token } });
    },
    CurrencyTypeShowBtn() {
      this.payment_method_show = false
      this.CurrencyTypeShow = true
    },
    get_list(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_coin_seller_info",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.userInfo = res.data.data.userInfo
          this.rulesData = res.data.data.level_up_rules
          this.deposit_rules = res.data.data.deposit_rules
          this.currency_type = res.data.data.currency_type
          this.coinselller_rank = res.data.data.coinselller_rank
          this.country_img = res.data.data.country_img
          this.payment_method_show =  !this.country_img
          this.recharge_usd_ratio = res.data.data.recharge_usd_ratio
          this.seller_security_deposit = res.data.data.seller_security_deposit
          this.availableBalance = res.data.data.userInfo.coin
          this.securityDeposit = res.data.data.userInfo.deposit_coin
          this.totalBalance = parseInt(this.availableBalance) + parseInt(this.securityDeposit)
          this.exchangeOptions = res.data.data.seller_exchange_list
          this.seller_exchange_rate = res.data.data.seller_exchange_rate
          this.seller_recharge_multiple = res.data.data.seller_recharge_multiple
          this.seller_exchange_multiple = res.data.data.seller_exchange_multiple
          this.ticket_name = res.data.data.ticket_name
          this.seller_currency_name = res.data.data.seller_currency_name
          this.currentLevel = res.data.data.currentLevel
          this.quit_endtime = res.data.data.userInfo.quit_endtime
          this.is_creator_agency = res.data.data.userInfo.is_creator_agency
          if (this.userInfo.status === '2'){
            this.activeTab = 'transfer'
          }
          this.startCountdown()
        }else{
          Toast(res.data.error)
        }
      })
    },
    copyId(id) {
      const element = document.getElementById(id);
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    goBack() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    showPaymentMethod() {
      if (this.country_img) {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        this.$router.push({ path: '/coin_seller_payment_method', query: { uid: uid, token: token } });
      } else {
        this.payment_method_show = true
      }
    },
    showRanking() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_ranking', query: { uid: uid, token: token } })
    },
    showDetails() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_details', query: { uid: uid, token: token } })
    },
    TransferBtn(){
      if (!this.transferFrom.coin) {
        return false
      }
      Dialog.confirm({
        title: this.$t('column.transfer_to_current_account'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=coin_seller_transfer",{
          params:{uid: uid, token: token, to_user_id: this.transferFrom.user_id, transfer_type: this.TransferActiveType, coin: this.transferFrom.coin}
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status !==1){
            Toast(res.data.error)
          }else{
            this.TransferActiveTypeBtn()
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.get_list()
              }
            });
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    ExchangeShowBtn(type) {
      if (type === 1) {
        this.exchangeFrom = this.exchangeOptions[this.exchangeOptionsSelect]
        if (this.exchangeFrom.seller_level > 0) {
          if (this.exchangeFrom.seller_level === 1) {
            this.exchangeFrom.seller_level_text = this.$t('column.beginner_seller')
          }else{
            this.exchangeFrom.seller_level_text = this.exchangeFrom.seller_level === 2 ? this.$t('column.standard_seller') :this.$t('column.senior_seller')
          }
        }else{
          this.exchangeFrom.seller_level_text = ''
        }
      }else{
        this.exchangeFrom = {
          id: 0,
          ticket: undefined,
          coin: 0,
          seller_level: 0,
          seller_level_text: '',
        }
      }
      this.ExchangeShow =  true
    },
    exchangeSubmit(){
      Dialog.confirm({
        title: this.$t('column.confirm_whether_to_exchange'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        // on confirm
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=exchange_ticket_to_coin",{
          params:{uid: uid, token: token, id: this.exchangeFrom.id, coin: this.exchangeFrom.coin, ticket: this.exchangeFrom.ticket }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          this.ExchangeShow =  false
          Toast({
            message: res.data.error,
            duration: 2000, // 持续2秒
            onClose: () => {
              // 这里写Toast关闭后要执行的方法
              this.get_list()
            }
          });

        })
      }).catch(() => {
        // on cancel
      });
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/coin_seller.vue